import { render, staticRenderFns } from "./ContractChild.vue?vue&type=template&id=5c886f10&"
import script from "./ContractChild.vue?vue&type=script&lang=js&"
export * from "./ContractChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports